import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { FormGroup,
  TreeSelect,
  SelectMultiple,
  StatusDot,
  Tooltip,
  Button,
  Icon,
  Dropdown,
  Select
} from "xsolla-uikit";












export const PAtableFilter = ({
  options = [],
  active,
  size = 'md',
  align = 'left',
  position = 'top',
  handleFilter = ()=>void(0),
  searchable,
  separated,
  tooltip = 'Filter by',
  tooltipFiltered = 'Show only: ',
}) => {

  const [currentFilterTooltip, setCurrentFilterTooltip] = useState();

  return (
    <div style={{fontSize: 14}}>
      {!active && <Dropdown
        onChange={(e)=>{
          handleFilter(e)
          setCurrentFilterTooltip(
            options.filter(
              oneOption => {
                return oneOption['value'] === e
              }
            )[0]['label']
          )
        }}
        searchable={searchable}
        align={align}
        position={position}
        size={size}
        // autosize={true}
        // appearance="tertiary"
        // type="inform"
        separated={separated}
        options={options}
      >

          <CssFilter active={active}>
            {/* <Tooltip label={tooltip}>
              <div style={{
                width: 26,
                height: 26,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}> */}
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0227 2.68309C13.6203 2.04413 13.1673 1 12.2924 1L1.00198 1C0.127098 1 -0.325976 2.04413 0.271648 2.68309L4.59224 7.3025C4.76551 7.48776 4.86191 7.73194 4.86191 7.98559V12.6783C4.86191 13.4674 5.73306 13.9456 6.39878 13.522L7.39878 12.8856C7.68723 12.7021 7.86191 12.3839 7.86191 12.042V8.59559C7.86191 8.34193 7.9583 8.09775 8.13157 7.9125L13.0227 2.68309Z" fill="currentColor"/>
              </svg>
              {/* </div>
            </Tooltip> */}
          </CssFilter>

      </Dropdown>}

      {!!active && <Tooltip label={<span style={{color: 'white'}}>{tooltipFiltered}<strong>{currentFilterTooltip}</strong></span>}><CssFilter active={active}
        onClick={()=>{
          handleFilter(false)
          setCurrentFilterTooltip(false)
        }}
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1268 11.1307C11.5173 10.7401 11.5173 10.107 11.1268 9.71646L8.25129 6.84096L11.1268 3.96547C11.5173 3.57494 11.5173 2.94178 11.1268 2.55125L10.9487 2.37319C10.5582 1.98267 9.92504 1.98267 9.53451 2.3732L6.65902 5.24869L3.78351 2.37319C3.39299 1.98266 2.75982 1.98266 2.3693 2.37318L2.19124 2.55124C1.80071 2.94177 1.80072 3.57493 2.19124 3.96546L5.06675 6.84096L2.19124 9.71647C1.80072 10.107 1.80072 10.7402 2.19124 11.1307L2.3693 11.3087C2.75982 11.6993 3.39299 11.6993 3.78351 11.3087L6.65902 8.43323L9.53451 11.3087C9.92504 11.6993 10.5582 11.6993 10.9487 11.3087L11.1268 11.1307Z" fill="#0073F7"/>
        </svg>
      </CssFilter>
      </Tooltip>}
    </div>
  )
}




export const PAtableFilter1 = ({
  options = [],
  active,
  handleFilter,
}) => {
  return (
    <CssSelectTrigger active={active}>
    <Select
      placeholder=""
      autosize={true}
      // align="right"
      name=""
      // size="xs"
      options={options}
      searchable={true}
      input={{
        name: "widgTheme",
        value: 0,
        onChange: (e)=>{
          handleFilter(e)
        }
      }}
  />
  </CssSelectTrigger>


  )
}



export const CssSelectTrigger = styled.div`
  position: relative;
  width: 28px;
  font-weight: normal;
  font-size: 15px;
  left: 10px;
  top: -2px;
  height: 28px;
  & button {
    /* display: none; */
    opacity:0;
    min-width: 28px;
    min-height: 28px;
    padding:0;
    font-size: 0;
  }
  & .xsui-input__icon .xsui-icon-dropdown-select::before {
    display: none;
  }
  & .xsui-input__icon{
    left: 0px;
    /* top: -2px; */
  }
  & .xsui-input__icon .xsui-icon-dropdown-select {
    cursor: pointer;
    top: -5px;
    right: auto;
    content:' ';
    display: block;
    position: absolute;
    z-index:1;
    border-radius: 32px;
    width: 28px;
    height: 28px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    color: ${({active}) => !!active ? '#0073f7' : '#c5d0db'};
    ${({active}) => !!active ?
    css`
      /* background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.86191 8.59559C7.86191 8.34193 7.9583 8.09775 8.13157 7.9125L13.0227 2.68309C13.6203 2.04413 13.1673 1 12.2924 1H1.00198C0.127098 1 -0.325976 2.04413 0.271648 2.68309L4.59224 7.3025C4.76551 7.48776 4.86191 7.73194 4.86191 7.98559V12.6783C4.86191 13.4674 5.73306 13.9456 6.39878 13.522L7.39878 12.8856C7.68723 12.7021 7.86191 12.3839 7.86191 12.042V8.59559Z' fill='%230073F7'/%3e%3c/svg%3e "); */
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.1268 11.1307C11.5173 10.7401 11.5173 10.107 11.1268 9.71646L8.25129 6.84096L11.1268 3.96547C11.5173 3.57494 11.5173 2.94178 11.1268 2.55125L10.9487 2.37319C10.5582 1.98267 9.92504 1.98267 9.53451 2.3732L6.65902 5.24869L3.78351 2.37319C3.39299 1.98266 2.75982 1.98266 2.3693 2.37318L2.19124 2.55124C1.80071 2.94177 1.80072 3.57493 2.19124 3.96546L5.06675 6.84096L2.19124 9.71647C1.80072 10.107 1.80072 10.7402 2.19124 11.1307L2.3693 11.3087C2.75982 11.6993 3.39299 11.6993 3.78351 11.3087L6.65902 8.43323L9.53451 11.3087C9.92504 11.6993 10.5582 11.6993 10.9487 11.3087L11.1268 11.1307Z' fill='%230073F7'/%3e%3c/svg%3e ");
      box-shadow: 0px 0px 0px 2px #0073f7;
    `
    : css`
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.86191 8.59559C7.86191 8.34193 7.9583 8.09775 8.13157 7.9125L13.0227 2.68309C13.6203 2.04413 13.1673 1 12.2924 1H1.00198C0.127098 1 -0.325976 2.04413 0.271648 2.68309L4.59224 7.3025C4.76551 7.48776 4.86191 7.73194 4.86191 7.98559V12.6783C4.86191 13.4674 5.73306 13.9456 6.39878 13.522L7.39878 12.8856C7.68723 12.7021 7.86191 12.3839 7.86191 12.042V8.59559Z' fill='%23C5D0DB'/%3e%3c/svg%3e ");
      box-shadow: 0px 0px 0px 1px #c5d0db;
    `};
  }
  &:hover .xsui-input__icon .xsui-icon-dropdown-select {
    box-shadow: 0px 0px 0px 2px #0073f7;
  }

`;











export function PAinfoCollapsible({
  title,
  // title = () => <span>Title</span>,
  children = "",
  indentation = "md",
  isOpen = false,
  handleChange = ()=> void(0),
  extra = '',
  counter,
}) {
  const [opened, setOpened] = useState(isOpen);

  let ind = 16;
  switch (indentation) {
    case "lg":
      ind = 24;
      break;
    case "md":
      ind = 16;
      break;
    case "sm":
      ind = 8;;
      break;
    case "xs":
      ind = 0;
      break;
    default:
      ind = 16;
      break;
  }


  const Title = ({children}) => (
      <div>{children}</div>
  );


  console.log('title = ', title);


  return (
    <div
      className={`gateway-manual-box ${
        !opened ? "gateway-manual-box--collapsed" : ""
      }`}
    >
      <div
        className="gateway-manual-box__title"
        style={{ display: "flex" }}
        onClick={() => {
          handleChange(!opened);
          setOpened(!opened);
        }}
      >
        <div className="gateway-manual-box__button">
          <img
            className="gateway-manual-box__title__icon"
            src="//cdn.xsolla.net/publisher-v4/chevron.0cc968.svg"
          />
        </div>
        {/* <PAh2 title={title}></PAh2> */}
        {typeof title === "function" ? title() : title}
        {typeof counter !== 'undefined' && <CssCounter>{counter}</CssCounter>}
        {/* {typeof title} */}

        {typeof extra !== 'undefined' && <div style={{flexGrow: 1, display: 'flex', justifyContent: 'flex-end'}}>
          {extra}
        </div>}

      </div>



      {opened && <div
        className="gateway-manual-box__content"
        style={{
          padding: `${ind/2}px ${ind}px ${ind}px ${ind}px`,
          overflow: `${opened ? "visible" : "hidden"}`,
          display: "static"
        }}
      >
        {children}
      </div>}
    </div>
  );
}



export const debugClicker = ()=>{
  return (<div style={{position: 'relative', background: 'red', color: 'white'}}>
    {Math.floor(Math.random() * 10)}
  </div>)
}



export const CssSwitchSub = styled.div`
  padding-left: 82px;
`;

export const CssTableLine = styled.div`
  overflow: visible;
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 16px 0px 16px 24px;
  &:nth-child(2n-1) {
    background-color: #fafbfc;
  }
`;

export const CssTableCountry = styled.div`
  display: flex;
  align-items: center;
  width: 190px;
`;

export const CssTableFlag = styled.div`
  width: 36px;
`;
export const CssTableDays = styled.div`
  display: flex;
  align-items: center;
  /* width: 84px; */
`;
export const CssInputDay = styled.div`
  flex-grow: 1;
  display: flex;
  flex-grow: 0;
  width: 64px;
  & input {
    min-width: 64px;
  }
  margin-right: 8px;
`;

export const SelectSquare = styled.div`
  /* width: ${({width}) => typeof width !== 'undefined' ? width : '44px'}; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  /* position: absolute; */
  /* z-index: 1; */
  right: 16px;

  & button {
    padding: 6px 8px;
    border: transparent;
    background: none;
    border-radius: 4px;
  }
  & button i {
    display: flex;
    align-items: center;
  }
  & .xsui-input__icon {
    display: none;
  }
`;







export const CSSedit = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  background: #0000007a;
  transition: opacity 150ms ease-in-out;
  opacity: 0;
  z-index: 1000;
  &:hover {
    opacity: 1;
  }
`;







// TABLE


export const CssLineHover = styled.div`
  &:nth-child(2n-1) {
    background-color: #fafbfc;
  }

  padding: ${({padding})=> !!padding ? padding : '24px 24px 24px 16px'};
  position: relative;
  ${({hover}) => (hover === 'true' || typeof hover === 'undefined') && css`
      &:hover {
        cursor: pointer;
        background-color: #f2f6ff;
      }
  `};
`;



export const CssSelectStatus = styled.div`
  /* white-space: nowrap; */
  /* display: flex; */
  /* align-items: center; */
  /* margin: 0px 0px 0 0px; */
`;
export const CssSelectItems = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 0 0 0px;
`;



export const CssSquareButton = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bolder;
  padding: 0;
  /* width: 100%; */
  padding-left: 8px;
  padding-right: 8px;
  /* background-color: #fff; */
  border: 1px solid #c5d0db;
  min-width: 64px;
  height: 36px;
  border-radius: 6px;
  &:not(:active):hover {
    background-color: #f5f9ff;
  }
`




export const CssThTd = styled.div`
  &>div {
    cursor: pointer;
    /* min-height: 64px; */
  }
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;

  ${({onClick, interactive})=> typeof onClick !== 'undefined' && interactive && css`
    cursor: pointer;
      position: relative;
      &:hover div {
        position: relative;
        z-index: 1;
        color: #0073f7;
    }

    &:hover {
        color: #0073f7;
        &::after {
          color: #0073f7;
        }
    }
  `}



  ${({onClick, interactive})=> typeof onClick !== 'undefined' && !interactive && css`
    &::before {
        transition: all 150ms ease-in-out;
        content: '';
        /* background-image: url("data:image/svg+xml,%3Csvg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.49639 5.33088C9.83335 5.67271 9.82941 6.22298 9.48758 6.55994L5.72693 10.2671C5.33358 10.6548 4.70038 10.6502 4.31267 10.2569L0.669124 6.55994C0.332195 6.21808 0.336196 5.66781 0.67806 5.33088V5.33088C1.01992 4.99395 1.57019 4.99795 1.90712 5.33981L5.03244 8.51091L8.26732 5.32207C8.60915 4.9851 9.15942 4.98905 9.49639 5.33088V5.33088Z' fill='%2303264D'/%3E%3C/svg%3E%0A"); */
        /* background-position: 97% 6%; */
        /* background-repeat: no-repeat; */
        text-transform: none;
        position: absolute;
        bottom: -6px;
        /* border: 1px solid transparent; */
        /* border-bottom: 1px dashed #c5d0db; */
        min-height: 16px;
        top: -6px;
        left: -8px;
        right: -36px;
        bottom:-8px;
        border-radius: 6px;
        /* background-color: #d4e5ff38; */
        /* border: 1px solid #d4e5ff38; */
        border: 1px solid #ebf1fb;
        /* border: 1px solid transparent; */
        /* background-color: #d4e5ff38; */
      }
    &::after {
        transition: all 150ms ease-in-out;
        content: "\\E020";
        font-size: 16px;
        color: #c5d0db;
        font-family: xsolla-icons;
        width: 24px;
        height: 24px;
        /* background-image: url("data:image/svg+xml,%3Csvg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.49639 5.33088C9.83335 5.67271 9.82941 6.22298 9.48758 6.55994L5.72693 10.2671C5.33358 10.6548 4.70038 10.6502 4.31267 10.2569L0.669124 6.55994C0.332195 6.21808 0.336196 5.66781 0.67806 5.33088V5.33088C1.01992 4.99395 1.57019 4.99795 1.90712 5.33981L5.03244 8.51091L8.26732 5.32207C8.60915 4.9851 9.15942 4.98905 9.49639 5.33088V5.33088Z' fill='%2303264D'/%3E%3C/svg%3E%0A"); */
        background-position: 97% 6%;
        background-repeat: no-repeat;
        text-transform: none;
        position: absolute;
        top: 0px;
        right: -34px;
      }
      &:hover {
        color: #0073f7;
        &::before {
          top: -6px;
          left: -8px;
          right: -36px;
          bottom:-8px;
          border-radius: 6px;
          background-color: #d4e5ff38;
          border: 1px solid #0073f7;
        }
      }
  `}



  ${({onClick, interactive})=> typeof onClick !== 'undefined' && !!interactive && css`
    width: 100%;
    padding-right: 8px;
    &::before {
        transition: all 150ms ease-in-out;
        content: '';
        text-transform: none;
        position: absolute;
        bottom: -6px;
        min-height: 16px;
        top: -36px;
        left: -12px;
        right: -12px;
        bottom: -36px;
      }
    &::after {
        transition: all 150ms ease-in-out;
        content: "\\E020";
        font-size: 16px;
        color: transparent;
        font-family: xsolla-icons;
        width: 24px;
        height: 24px;
        /* background-image: url("data:image/svg+xml,%3Csvg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.49639 5.33088C9.83335 5.67271 9.82941 6.22298 9.48758 6.55994L5.72693 10.2671C5.33358 10.6548 4.70038 10.6502 4.31267 10.2569L0.669124 6.55994C0.332195 6.21808 0.336196 5.66781 0.67806 5.33088V5.33088C1.01992 4.99395 1.57019 4.99795 1.90712 5.33981L5.03244 8.51091L8.26732 5.32207C8.60915 4.9851 9.15942 4.98905 9.49639 5.33088V5.33088Z' fill='%2303264D'/%3E%3C/svg%3E%0A"); */
        background-position: 97% 6%;
        background-repeat: no-repeat;
        text-transform: none;
        position: absolute;
        top: 0px;
        right: 0px;
      }
      &:hover {
        color: #0073f7;
        &::before {
          background-color: #d4e5ff38;
          /* border: 1px solid #0073f7; */
        }
        &::after {
          color: #c5d0db;
        }
      }
  `}




`;

export const CssThFilt0 = styled.div`
  display: flex;
`;

export const CssTh = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({cols}) => !!cols ? cols : '1.25fr 2fr 4fr 2fr 1.5fr 0.4fr'};
  grid-column-gap: 16px;
  color: #747e8a;
`;


export const CssClick = styled.div`
  position: absolute;
  width: 86%;
  top: 0;
  left: 0;
  bottom: 0;
`;


export const ButtonSquare  = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  min-width: 24px;
  min-height: 24px;
  justify-content: center;
  padding: 0;
  background-color: #fff;
  border: 1px solid rgba(0,115,247,.32);
  border-radius: 4px;
  color: #0073f7;
`;









export const CssCounter = styled.span`
  margin-left: 0.6em;
  color: currentColor;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  /* padding: 0 8px; */
  /* height: 24px; */
  padding: 2px 10px;
  height: 20px;
  /* font-weight: bolder; */
  margin-bottom: -2px;
  font-size: 11px;
  display: flex;
  border: 1px solid #baceec;
  border-radius: 100px;
  ${({appearance}) => appearance === 'warning' && css`
      background-color: #ffc500;
      color: white;
      border: none;
      padding: 2px 4px;
      font-weight: bolder;
  `}
  ${({appearance}) => appearance === 'error' && css`
      background-color: #eb002f;
      color: white;
      border: none;
      padding: 2px 4px;
      font-weight: bolder;
  `}
`;








export const CssFilter = styled.span`
  cursor: pointer;
  position: relative;
  margin-left: 0.6em;
  color: ${({active}) => !!active ? '#0073f7' : '#c5d0db'};
  ${({active}) => !!active ?
  css`
    box-shadow: 0px 0px 0px 2px #0073f7;
  `
  : css`
    box-shadow: 0px 0px 0px 1px #c5d0db;
  `};
  justify-content: center;
  align-items: center;
  min-width: 26px;
  height: 26px;
  margin-top: -4px;
  margin-bottom: -4px;
  margin-left: 8px;
  font-size: 11px;
  display: flex;
  border-radius: 100px;
  transition: all 250ms ease-in-out;
  &:hover {
    box-shadow: 0px 0px 0px 2px #0073f7;
  };
  &:active {
    box-shadow: 0px 0px 0px 2px #0073f7;
    color: #0073f7;
  };



`;








const defOptions = [
  { label: "Windows", value: "windows" },
  { label: "Linux", value: "linux" },
  { label: "Mac", value: "mac" },
  { label: "Mac", value: "mac2" },
  { label: "Mac", value: "mac3" },
  { label: "Mac", value: "mac4" },
  { label: "Mac", value: "mac5" },
  { label: "Mac", value: "mac6" },
  { label: "Mac", value: "mac7" }
];

export function PaSelectMultiple({
  options = defOptions,
  initial = [],
  size,
  handleSelect = ()=>void(0),
  checkbox = true,
  // icons = ['✅', '🔴'],
  // icons = ['◉', '◎'],
  // icons = ['☑︎', '☐'],
  icons = ['✓', ' '],
  style,
}) {
  const [state, setState] = React.useState(
    [...initial],
  );
  const [opts, setOpts] = React.useState(
    [...options]
  );

  useEffect(() => {

    if (checkbox) setOpts(opts.map(({label, value})=> {
      // console.log('label.split(1) = ', label.split('1'));
      let newLabel = label.split(`${icons[0]} `)[1];
      if (!newLabel) newLabel = label.split(`${icons[1]} `)[1];
      label = newLabel ? newLabel : label
      console.log('label = ', label);

      return ({
        label: `${state.indexOf(value) > -1 ? icons[0] : icons[1]} ${label}`,
        value: value,
      })
    }))

  }, [state])


  useEffect(() => {
    handleSelect(state)
  }, [state])

  return (
    <CssSelMul {...style}>
    <SelectMultiple
      size={size}
      name="values"
      options={opts}
      fields={{
        getAll: () => [...state],
        push: a => setState([...state, a]),
        remove: index => {
          let newOptions = [...state];
          newOptions.splice(index, 1);
          setState([...newOptions]);
        }
      }}
    />

    {/* <TreeSelect

        name="basic"
        allowMultiSelect={true}
        input={{
          value: [{id: 3, label: 'Planes'}],
          // onChange: multiple => setState({multiple})
        }}
        options={options}
      /> */}


    </CssSelMul>
  );
}






export const CssChartsGrid = styled.div`
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(360px, 1fr)); */
  grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
  grid-template-rows: repeat(auto-fit, minmax(360px, auto));
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  /* ${({cols}) => !!cols && css`
    grid-template-columns: ${cols}
  `} */
  ${({charts}) => charts && Math.abs(charts.length % 2) === 1  && css` //TODO: последний чарт во всю строку
    & *:nth-child(${charts.length}) {
      grid-column-start: 1;
      grid-column-end: 3;
      grid-row-start: 2;
      grid-row-end: 2;
    }
  `}

`;



export const CssSelMul = styled.span`
  & .xsui-input--read-only {
    overflow: hidden;
    width: 200px;
  }
  & .xsui-input {
    background: transparent;
  }
`;






export const PAvCpreview = ({
  sku,
  number,
  name,
  icon = true,
  image_url, amount, title, titleMultiple}) => {
  return (
    <span className="l_flex">


      {!!icon && !!image_url && <CssVCimage
        style={{width: 18, height: 18, margin: '0 4px', marginRight: '4px'}}
        image_url={image_url}

      />}

      {!image_url && <span style={{marginRight: '4px'}}>{sku}</span>}

      {number !== false && !!amount && amount}

      {name !== false && (name || amount === 0 || amount === 1) && <span style={{marginLeft: '4px'}}>{title}</span>}
      {name !== false && !!amount && amount > 1 && <span style={{marginLeft: '4px'}}>{titleMultiple}</span>}

    </span>
  )
}

export const CssVCimages = ({image_url, amount, style}) => {
  let a = []
  for (let index = 0; index < amount; index++) {
    a.push('')
  }

  if (!a && a.length < 2) {
    return <CssVCimage image_url={image_url} amount={false} {...style}/>
  }
    else
  {
    return (<CssImagesGrid image_url={image_url} amount={amount} {...style}>
      {a.map((aa, ind)=>{
        return (
          <CssVCimage image_url={image_url} amount={amount}>
          {/* {ind} */}
          </CssVCimage>
        )
      })}
    </CssImagesGrid>)
  }

}







export const CssUserImage = styled.div`
  /* overflow: hidden; */
  background-image: url(${({image_url}) => image_url});
  background-size: contain;
  background-repeat: no-repeat;

  ${({amount})=> (!amount) && css`
    width: 120px;
    height: 120px;
  `};
  ${({amount})=> (amount === 1) && css`
    width: 44px;
    height: 44px;
  `};
  ${({amount})=> (amount > 1 && amount < 6) && css`
    width: 24px;
    height: 24px;
  `};
  ${({amount})=> (amount >= 5) && css`
    width: 16px;
    height: 16px;
  `};
  ${({amount})=> (amount > 16) && css`
    width: 16px;
    height: 16px;
  `};
`



export const CssVCimage = styled.span`
  /* overflow: hidden; */
  background-image: url(${({image_url}) => image_url});
  background-size: contain;
  background-repeat: no-repeat;
  ${({amount})=> (!amount) && css`
    width: 120px;
    height: 120px;
  `};
  ${({amount})=> (amount === 1) && css`
    width: 44px;
    height: 44px;
  `};
  ${({amount})=> (amount > 1 && amount < 5) && css`
    width: 24px;
    height: 24px;
  `};
  ${({amount})=> (amount >= 5) && css`
    width: 16px;
    height: 16px;
  `};
  ${({amount})=> (amount > 16) && css`
    width: 16px;
    height: 16px;
  `};
  /* ${({amount})=> amount !== 1 && css` */
    /* background-size: ${ 100 / (amount / 2)}%; */
  /* `}; */
`


export const MenuCont = styled.div`
  min-height: 60px;
  /* background-color: #D6E0E7; */
  background-color: #f7faff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.2s ease;
  ${props =>
    props.menu &&
    css`
      /* min-height: 800px; */
    `}
  ${props =>
    props.hide &&
    css`
      opacity: 0;
    `}
`;


export const MenuUl = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1440px;
  display: flex;
  /* display: grid; */
  /* grid-template-columns: repeat(4, minmax(100px, auto)); */
  /* grid-template-columns: repeat(
    ${props => props.count},
    ${props => `${100 / props.count}%`}
  ); */
  /* place-content: center center; */
  /* grid-column-gap: ${props => `${props.count > 4 ? 3 : props.count}%`}; */
`;






export const CssImagesGrid = styled.div`
  border-radius: 8px;
  border: 1px solid #c5d0db;
  padding: 8px 8px 8px 8px;
  width: 64px;
  height: 60px;
  overflow: hidden;
  /* display: grid; */
  display: flex;
  flex-wrap: wrap;
  place-content: center;
  position: relative;
  /* ${({amount, image_url})=> amount !== 1 && css` */
    /* grid-template-columns: repeat(auto-fit, minmax(16px, 1fr));
    grid-template-rows: repeat(auto-fit, minmax(16px, 1fr));
    grid-column-gap: 4px;
    grid-row-gap: 4px; */
    /* grid-template-columns: repeat((Math.ceil(amount/2+0.1), minmax(24px, 1fr));
    grid-template-rows: repeat((Math.ceil(amount/2), minmax(24px, 1fr)); */
  /* `} */
  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
    z-index:0;
    ${({image_url})=> image_url && css`
      background-image: url(${image_url});
      background-size: 300%;
      background-position: 50% 50%;
      filter: blur(40px);
      opacity: 0.7;
    `
    }
  }
`







export const ButtonOutlineWhite = styled.div`
  & .xsui-button--appearance-outline {
    background: transparent;
    border-color: white;
    color: white;
  }
  & .xsui-button--size-md {
    min-width: initial;
    /* padding-left: 8px;
    padding-right: 8px; */
  }

  &:hover .xsui-button--appearance-outline:not(:active):not(.xsui-button--focused):hover {
    border-color: white;
    color: white;
    opacity: 0.6;
  }
`


export const CSSonlyMob = styled.div`
  display: none;
  @media (max-width: 991px) {
    display: none;
  }

  @media (max-width: 767px) {
    display: block;
  }

  @media (max-width: 479px) {
    display: block;
  }
`

export const CSSonlyWeb = styled.div`
  display: block;
  @media (max-width: 991px) {
    display: block;
  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (max-width: 479px) {
    display: none;
  }
`

export const CSSbigInput = styled.div`

    display: flex;
    font-size: 24px;
    font-weight: bolder;
    color: rgba(255,255,255, 1);
    /* color: rgba(255,255,255,0.4); */
    white-space: nowrap;
    align-items: center;

  & input {
    text-align: center;

    display: block;
    width: 100%;
    border: 0px solid transparent;
    border-bottom: 2px solid rgba(255,255,255,0.4);
    padding: 4px;

    margin: 0;
    background: transparent;
    box-shadow: inset 0 0 0 1px transparent;
  }
  &>input::-webkit-input-placeholder,
  &>input::-moz-placeholder,
  &>input:-ms-input-placeholder,
  &>input:-moz-placeholder {
    opacity: 0.8;

    /* border: 1px solid red; */
  }
`